module.exports = __webpack_public_path__ + "static/media/icon-dashboard-partner.7325dcad.svg";